<script setup lang="ts">
import { computed, type HTMLAttributes } from 'vue'
import { NumberFieldInput } from 'reka-ui'
import { cn } from '@ds/lib/utils'
import { InputSize, SIZE_CLASS } from '../input'

/*
 * Styled to be indistinguishable from DSInput — a number field sitting in a
 * grid beside text fields must not look like a different control. Metrics come
 * from the input's own SIZE_CLASS rather than a copy, so the two cannot drift.
 *
 * (derived) The registry ships `text-center` here, which suits its
 * increment/decrement-flanked demo; a money field in a form column reads
 * left-aligned like every other field.
 */
const props = defineProps<{
  class?: HTMLAttributes['class']
  size?: InputSize
}>()

const inputSizeClass = computed(() => SIZE_CLASS[props.size ?? 'md'])
</script>

<template>
  <NumberFieldInput
    data-slot="input"
    :class="cn(
      // See DSInput on why `ds-control` is load-bearing (@tailwindcss/forms).
      'ds-control',
      'flex w-full',
      inputSizeClass,
      'bg-card text-foreground placeholder:text-foreground/35',
      'font-ds font-medium',
      'border border-input rounded-ds-md',
      'transition-[border-color,box-shadow] duration-ds-fast ease-ds-standard',
      'disabled:bg-muted disabled:cursor-not-allowed',
      props.class,
    )"
  />
</template>
